
import PrimaryButton from '@/components/shared/PrimaryButton';
import FinAgentService from '@/service/FinAgentService';
import { backendExceptionHandler } from '@/mixins';
import _ from 'lodash'

export default {
    name: 'FinAgentSaveSnippetModal',

    components: {
        PrimaryButton,
    },

    mixins: [backendExceptionHandler],

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        messageId: {
            type: Number,
            default: 0,
        },
        defaultTitle: {
            type: String,
            default: '',
        }
    },

    emits: ['input', 'save-success'],

    data() {
        return {
            title: '',
            isSubmitting: false,
            errorMessage: '',
        };
    },

    computed: {
        submitDisabled() {
            return !this.title.trim() || this.isSubmitting;
        },
    },

    watch: {
        value(visible) {
            this.reset();
            if (visible) {
                this.title = this.defaultTitle;
            }
        },
    },

    created() {
        this.finAgentService = new FinAgentService(this.$axios);
        this.rules = {
            required: value => !!value?.trim() || this.$t('components.finAgentSnippet.titleRequired'),
        }
        this.debouncedSubmit = _.debounce(this.submit, 300); 
    },

    methods: {
        reset() {
            this.title = '';
        },
        closeDialog() {
            this.$emit('input', false);
        },
        async submit() {
            if (this.submitDisabled) {
                return;
            }

            try {
                this.isSubmitting = true;
                const createdSnippet = await this.finAgentService.createSnippet(this.messageId, this.title.trim());
                this.showSuccess();
                this.$emit('save-success', createdSnippet);
                this.closeDialog();
            } catch (error) {
                this.handleBackendException(error, this.$t('components.finAgentSnippet.errorWhenSave'));
                this.showError();
            } finally {
                this.isSubmitting = false;
            }
        },
        showSuccess() {
            this.$store.commit('snackbar/updateType', 'success');
            this.$store.commit('snackbar/updateMessage', this.$t('components.finAgentSnippet.saveSuccess'));
        },
        showError() {
            this.$store.commit('snackbar/updateType', 'error');
            this.$store.commit('snackbar/updateMessage', this.errorMessage);
        }
    },
}
